import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Contract } from "../../../model/contract";
import { MatDialog } from "@angular/material/dialog";
import { ContractDialogComponent } from "../contract-dialog/contract-dialog.component";
import { CreateContractDialogComponent } from "../create-contract-dialog/create-contract-dialog.component";
import { Constants } from "../../../utils/constants";
import { ContractsService } from "../../../services/contracts.service";
import { AuthService } from "../../../services/auth.service";
import { EMPTY, Observable, of } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { SnackService } from "../../../services/snack.service";
import { SplitCamelCasePipe } from "../../../pipes/split-camel-case.pipe";
import { DialogsService } from "../../../services/dialogs.service";


@Component({
  selector: 'aw-contract-card',
  templateUrl: './contract-card-dashboard.component.html',
  styleUrls: ['./contract-card-dashboard.component.scss']
})
export class ContractCardDashboardComponent implements OnInit, AfterViewInit {

  contract?: Contract;
  contractStatus = Constants.contractStatuses;
  roles = Constants.roles;
  loading = false;
  hidden = false;
  disabled = false;
  loggedUser: any;
  private contract$!: Observable<Contract>;

  @Output() onElementRemoved = new EventEmitter<Contract>();


  constructor(
    public dialog: MatDialog,
    public dialogsService: DialogsService,
    public authService: AuthService,
    public contractsService: ContractsService,
    public snackService: SnackService,
    public splitCamelCase: SplitCamelCasePipe,
  ) {
  }

  @Input() set element(element: Contract) {
    this.contract = element;
  }

  ngOnInit(): void {
    this.loggedUser = this.authService.loggedUser();
  }

  ngAfterViewInit(): void {
    this.contract$ =
      of(true)
        .pipe(
          tap(() => this.loading = true),
          switchMap(() => this.contractsService.getContract(this.contract?.id)),
          tap(x => {
            this.contract = x;
            this.loading = false;
          })
        );
  }

  openStatusDialog(): void {
    this.disabled = true;
    this.dialog.open(ContractDialogComponent, { data: this.contract })
      .afterClosed()
      .pipe(switchMap(value => value ? this.contract$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
          this.snackService.success(`Contract status set to ${this.splitCamelCase.transform(this.contract?.status)}`);
        },
        (error) => {
          this.disabled = false;
          this.snackService.error(error.message);
        }, () => {
          this.disabled = false;
        });
  }

  openEditDialog(): void {
    this.disabled = true;
    this.dialog.open(CreateContractDialogComponent, { data: this.contract })
      .afterClosed()
      .pipe(switchMap(value => value ? this.contract$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.disabled = false;
          this.snackService.error(error.message);
        }, () => {
          this.disabled = false;
        });
  }

  deleteContract(): void {
    this.disabled = true;
    this.loading = true;
    this.dialogsService
      .confirm('Delete contract', `Are you sure you want to delete the contract "${this.contract?.title}"?`)
      .pipe(
        switchMap((value) => value ?
          this.contractsService.deleteContract(<number>this.contract?.id) : EMPTY)
      )
      .subscribe(() => {
        this.disabled = false;
        this.onElementRemoved.emit(this.contract);
        this.snackService.success('Contract deleted!');
        this.loading = false;
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
        this.loading = false;
      },
        () => {
          this.disabled = false;
          this.loading = false;
        });

  }



}
